<template>
  <div class="lyear-layout-web">
    <div class="lyear-layout-container">
      <!--左侧导航-->
      <user-left></user-left>
      <!--End 左侧导航-->
      
      <!--头部信息-->
      <user-head></user-head>
      <!--End 头部信息-->
      
      <!--页面主要内容-->
      <main class="lyear-layout-content">
        
        <div class="container-fluid">
          
          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-toolbar clearfix">
                  <form class="pull-right search-bar" method="get" action="#!" role="form">
                    <div class="input-group">
                      <Col span="12">
													<DatePicker　@on-change="changeDate" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px"></DatePicker>
											</Col>
                    </div>
                  </form>
                  <div class="toolbar-btn-action">
                    <a class="btn btn-p m-r-5" :class="payStatus === ''?'active':''" @click="downrecord(1)"><i class="mdi mdi-plus"></i> 全部订单</a>
                    <a class="btn btn-s m-r-5" :class="payStatus === 1?'active':''" @click="downrecord(1,1)"><i class="mdi mdi-check"></i> 已支付订单</a>
                    <a class="btn btn-w m-r-5" :class="payStatus === 0?'active':''" @click="downrecord(1,0)"><i class="mdi mdi-block-helper"></i>未支付订单</a>
                    <!-- <a class="btn btn-danger" @click="delete1 = true" href="#!"><i class="mdi mdi-window-close"></i> 删除</a> -->
                  </div>
                </div>
                <div class="card-body">
                  
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                        <!--  <th>
                            <label class="lyear-checkbox checkbox-primary">
                              <input type="checkbox" :checked="ischeck" @change="changeCheck(item.id)"><span></span>
                            </label>
                          </th> -->
                          <th>订单号</th>
													<th>下单时间</th>
                          <th>名称</th>
                          <!-- <th>栏目</th> -->
                          <!-- <th>作者</th> -->
                          <th>价格（元）</th>
                          <th>状态</th>
                          <!-- <th>操作</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item,index in downList" :key="index">
                          <!-- <td>
                            <label class="lyear-checkbox checkbox-primary">
                              <input type="checkbox" :checked="ischeck" @change="changeCheck(item.id)"><span></span>
                            </label>
                          </td> -->
                          <td>{{item.orderSn}}</td>
                          <td>{{item.createTime}}</td>
                          <td class="shou"  @click="enterDetail(item.orderItemList[0].productThirdIden, 25)">{{item.orderItemList[0].productName}}</td>
                          <!-- <td>历史资料</td> -->
                          <!-- <td>金庸</td> -->
                          <td>{{item.orderItemList[0].productPrice}}</td>
                          <td>
														<font class="text-warning" v-show="item.status==0">待付款</font>
														<font class="text-warning" v-show="item.status==1">待发货</font>
														<font class="text-warning" v-show="item.status==2">已发货</font>
														<font class="text-success" v-show="item.status==3">已完成</font>
														<font class="text-warning" v-show="item.status==4">已关闭</font>
														<font class="text-warning" v-show="item.status==5">无效订单</font>
													</td>
                          <!-- <td>
                            <div class="btn-group">
                              <a class="btn btn-xs btn-default" href="#!" title="编辑" data-toggle="tooltip"><i class="mdi mdi-pencil"></i></a>
                              <a class="btn btn-xs btn-default" href="#!" title="删除" data-toggle="tooltip"><i class="mdi mdi-window-close"></i></a>
                            </div>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
       
									<!-- 分页器 -->
									<div class="pagination">
										<Page class-name="page-class" :current="pageNum" :total="total" :page-size="10" @on-change="changePage" />
									</div>
									         
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
        
      </main>
      <!--End 页面主要内容-->
    </div>
		
		<Modal
				v-model="delete1"
				title="友情提示"
				@on-ok="collectDel"
				@on-cancel="">
				<p>是否确认删除选中的收藏列表</p>
		</Modal>
  </div>
</template>

<script>
import userLeft from './user_left.vue'
import userHead from './user_head.vue'
export default {
  data () {
    return {
			downList: [],
			total: 0,
			delId: [],
			ischeck: false,
			delete1: false,
			pageNum:1,
			payStatus:'',
			beginTime: '',
			endTime: '',
		}
  },
	
	components: {
		userLeft,
		userHead
	},
	
  created () {},
	
	mounted () {
		this.downrecord()
	},

  methods: {
		// 我的订单
		async downrecord (pageNum=1,payStatus='') {
			let _this = this
			_this.payStatus = payStatus
			_this.$Spin.show()
			let data = {
				pageNum,
				pageSize:10,
				v_stamp: 1612162986287,
				orderType: 0,
				memberId:localStorage.getItem('id'),
				payStatus,
				beginTime: _this.beginTime,
				endTime: _this.endTime
			}
			const res = await _this.get('/order/getRHEBOrderList.do', data)
			_this.downList = res.data
			_this.total = res.totalCount - 0
			_this.$Spin.hide()
		},
		
		changeDate (e) {
			let _this = this 
			if (e[0] == '') {
				_this.beginTime  = ''
				_this.endTime = ''
			} else {
				_this.beginTime  = e[0] + ' 00:00:00'
				_this.endTime = e[1] + ' 24:00:00'
			}
			
			_this.pageNum = 1
			_this.downrecord()
		},
		
		// 页码改变
		changePage (page) {
			this.downrecord(page,this.payStatus)
		},
		
		// 跳转
		enterDetail (id,tid) {
				if (tid == 25 || tid == 837) {
					let link = this.$router.resolve({path:'/img_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				} else if (tid == 28) {
					let link = this.$router.resolve({path:'/audio_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				} else {
					let link = this.$router.resolve({path:'/video_detail',query: {id,tid}})
					window.open(link.href, "_blank")
				}
		},
		
		// 单选框选中与不选中
		changeCheck (id) {
			// console.log(id)
			let _this = this
			console.log()
			if (_this.delId.includes(id)) {
				let index = _this.delId.findIndex(x =>  x==id)
				_this.delId.splice(index,1)
			} else {
				_this.delId.push(id)
			}
		},
		
		// 批量删除收藏
		async collectDel (id = 0) {
			let _this = this
			if (id) {
				const res = await _this.delete_api('/members/collects?delId=' + id)
				_this.ischeck = false
				_this.$Message.success({
					content: '删除成功'
				})
			} else {
				if (!_this.delId.length) {
					return _this.$Message.error({
						content: '请选择相应的收藏资源'
					})
				}
				const res = await _this.delete_api('/members/collects?delId=' + _this.delId)
				_this.ischeck = false
				_this.$Message.success({
					content: '删除成功'
				})
			}
			
			window.location.reload()
			// _this.collectList()
		},
		
	}
}
</script>

<style lang="less" scoped>
th,td {
	text-align: center;
}
.active {
	background-color: #fff!important;
}
.btn-p {
	background-color: #2ba99d;
	border: 1px solid #2ba99d;
	width: 150px;
	color: #fff!important;
}
.btn-p.active {
	color: #2ba99d!important;
}
.btn-s.active {
	color: #15c377!important;
}
.btn-w.active {
	color: #faa64b!important;
}
.btn-s {
	background-color: #15c377;
	border: 1px solid #15c377;
	width: 150px;
	color: #fff!important;
}
.btn-w {
	background-color: #faa64b;
	border: 1px solid #faa64b;
	width: 120px;
	color: #fff!important;
}
</style>
